interface OnboardingImageProps {
  /** Image source URL. */
  src: string;
  /** Accessible alt text for the reference image. */
  alt: string;
}

/**
 * Renders the right-column reference image. Hidden on viewports < lg via the
 * `hidden lg:block` wrapper. The image is decorative for the structural shell
 * and may be `null` in follow-up content specs.
 */
export const OnboardingImage = ({ src, alt }: OnboardingImageProps) => {
  if (!src) {
    return null;
  }

  return (
    <aside
      aria-hidden="false"
      className="hidden lg:flex items-center justify-center w-full h-full bg-orange-50"
    >
      <img
        src={src}
        alt={alt}
        className="w-1/2 h-auto max-h-[80vh] object-contain"
      />
    </aside>
  );
};
